import React from 'react'
import { css, Global, useTheme } from '@emotion/react'
import get from 'lodash/get'
import font from '@/styles/font'
import anchor from '@/styles/overrides/anchor'
import alert from '@/styles/overrides/alert'
import avatar from '@/styles/overrides/avatar'
import button from '@/styles/overrides/button'
import card from '@/styles/overrides/card'
import checkbox from '@/styles/overrides/checkbox'
import dropdownMenu from '@/styles/overrides/dropdownMenu'
import form from '@/styles/overrides/form'
import input from '@/styles/overrides/input'
import link from '@/styles/overrides/link'
import modal from '@/styles/overrides/modal'
import pagination from '@/styles/overrides/pagination'
import segmented from '@/styles/overrides/segmented'
import select from '@/styles/overrides/select'
import space from '@/styles/overrides/space'
import swiper from '@/styles/overrides/swiper'
import table from '@/styles/overrides/table'
import tooltip from '@/styles/overrides/tooltip'
import tabs from '@/styles/overrides/tabs'
import tree from '@/styles/overrides/tree'
import typography from './overrides/typography'

type GlobalStylesProps = {
    bodyBg?: string
}

const GlobalStyles = ({ bodyBg = 'colors.common.black' }: GlobalStylesProps) => {
    const theme = useTheme()
    const globalCss = css`
        body {
            background-color: ${get(theme, bodyBg)};
        }
        ${anchor}
        ${alert}
        ${avatar}
        ${button}
        ${card}
        ${checkbox}
        ${dropdownMenu}
        ${font}
        ${form}
        ${input}
        ${link}
        ${modal}
        ${pagination}
        ${segmented}
        ${select}
        ${space}
        ${swiper}
        ${table}
        ${tooltip}
        ${tabs}
        ${tree}
        ${typography}
    `

    return <Global styles={globalCss} />
}

export default GlobalStyles
